module.exports = __webpack_public_path__ + "files/Cookiebeleid.106ad3a7.pdf";